import { IFieldInstance } from "../../types/fieldInstance.interface";

export function compareStrings(string1: string, string2: string) {
  let str1 = string1 && string1.replace(/\s/g, "").toLowerCase();
  let str2 = string2 && string2.replace(/\s/g, "").toLowerCase();
  if (str1 === str2) {
    return true;
  } else {
    return false;
  }
}

export function findStringInArray(string: string, array: string[]): boolean {
  return array.some((el) => compareStrings(el, string));
}

export const shouldRenderInTab = (
  fieldTabs: string[][],
  incidentType: string,
  activeTab: string
) => {
  // find incidentType in fieldTabs.flat(), if it exists, compare 2nd element to activeTab
  const allTabDetails = fieldTabs.flat();
  const incidentTabIndex = allTabDetails.indexOf(incidentType);
  return incidentTabIndex !== -1
    ? compareStrings(allTabDetails[incidentTabIndex + 1], activeTab)
    : false;
};

export function checkIncidentType(
  incidentType: string,
  validIncidentTypes: string[]
) {
  // given a label, returns the id of the incident, make form save and return id instead?
  return validIncidentTypes.includes(incidentType);
}

export const isConditionBoolean = (condition: string) =>
  compareStrings(condition, "True") || compareStrings(condition, "False");

export const isMulti = (fieldType: string) =>
  [
    "Branched Multi-Select as CheckBoxes",
    "Multi-Select as CheckBoxes",
    "Multi-Select Picklist",
  ].includes(fieldType);

export const isValueSelected = (parentArray: any[], subsetArray: any[]) => {
  if (!parentArray || !subsetArray) return false;
  return subsetArray.some((el: any) => {
    let isSelected = parentArray.includes(el);
    if (typeof el === "string" && !isSelected) {
      isSelected = !!parentArray.find((val) => compareStrings(val, el));
    }
    return isSelected;
  });
};

const shouldRenderIfBoolean = (
  field: IFieldInstance,
  parentField: IFieldInstance,
  values: any
) => {
  if (parentField.fieldType === "Togglebox") {
    return field.fieldType === "Text" ? false : values[parentField.fieldName];
  } else if (parentField.fieldType === "Checkbox") {
    return values[parentField.fieldName];
  } else return false;
};

const shouldRenderWoundComp = (
  parentField: IFieldInstance,
  condition: string[],
  values: any
) => {
  return parentField.fieldType === "CustomWoundComp"
    ? false
    : findStringInArray(String(values[parentField.fieldName]), condition);
};

const shouldRenderIfArrayOfConditions = (
  condition: string[],
  parentField: IFieldInstance,
  values: any
) => {
  if (isMulti(parentField.fieldType)) {
    return condition.length === parentField.values.length
      ? !!(
          values[parentField.fieldName] && values[parentField.fieldName].length
        )
      : isValueSelected(values[parentField.fieldName], condition);
  } else {
    shouldRenderWoundComp(parentField, condition, values);
    return findStringInArray(String(values[parentField.fieldName]), condition);
  }
};

const checkRenderCondition = (
  condition: string | string[],
  field: IFieldInstance,
  parentField: IFieldInstance,
  values: any
): boolean => {
  if (typeof condition === "string") {
    if (isConditionBoolean(condition)) {
      return shouldRenderIfBoolean(field, parentField, values);
    } else {
      return isMulti(parentField.fieldType)
        ? Array.isArray(values[parentField.fieldName]) &&
            findStringInArray(condition, values[parentField.fieldName])
        : compareStrings(values[parentField.fieldName], condition);
    }
  } else if (Array.isArray(condition)) {
    return shouldRenderIfArrayOfConditions(condition, parentField, values);
  } else {
    return false;
  }
};

export const shouldFieldRender = (
  field: IFieldInstance,
  values: { [x: string]: any },
  findFieldById: (id: string) => IFieldInstance
) => {
  const condition = field.condition;
  let parentField = field.parentFieldId && findFieldById(field.parentFieldId);
  if (parentField) {
    if (condition) {
      const shouldRender = checkRenderCondition(
        condition,
        field,
        parentField,
        values
      );
      if (parentField.parentFieldId) {
        const nthParentField = findFieldById(parentField.parentFieldId);
        let isParentActive = checkRenderCondition(
          parentField.condition,
          parentField,
          nthParentField,
          values
        );
        if (parentField.fieldType === "Togglebox") {
          isParentActive = values[parentField.fieldName];
        }
        return isParentActive && shouldRender;
      }
      return shouldRender;
    } else {
      // If there is no condition, do not render the child as a standalone field.
      // Inline child controls are rendered inside their parent components.
      return false;
    }
  } else {
    return true;
  }
};
